import * as React from 'react'
import EscapeHandler from '../lib/escape-handler'

export const withEscapeHandler = (WrappedComponent) => {
  return class extends React.Component<any, any> {
    componentDidMount() {
      EscapeHandler.registerEscapeListener(this.handleEscape)
    }

    componentWillUnmount() {
      EscapeHandler.removeEscapeListener(this.handleEscape)
    }

    handleEscape = () => {
      console.log('a men klickade på escape då...')
      this.props.onEscapePress && this.props.onEscapePress()
    }

    render() {
      return <WrappedComponent {...this.props} />
    }
  }
}
